import { useState, useEffect } from 'react';
import SEO from '../../components/SEO';
import AdUnit from '../../components/AdUnit';

function TimestampConverter() {
  const [ts, setTs] = useState(Math.floor(Date.now() / 1000));
  const [dateStr, setDateStr] = useState('');
  const [now, setNow] = useState(Math.floor(Date.now() / 1000));
  const [copied, setCopied] = useState('');

  useEffect(function () {
    var timer = setInterval(function () { setNow(Math.floor(Date.now() / 1000)); }, 1000);
    return function () { clearInterval(timer); };
  }, []);

  useEffect(function () {
    var d = new Date(ts * 1000);
    if (isNaN(d.getTime())) { setDateStr('Invalid timestamp'); return; }
    setDateStr(d.toUTCString() + '\n' + d.toISOString() + '\n' + d.toLocaleString());
  }, [ts]);

  var fromDate = function () {
    var d = new Date(dateStr.split('\n')[0]);
    if (!isNaN(d.getTime())) setTs(Math.floor(d.getTime() / 1000));
  };

  var copy = function (text, label) {
    navigator.clipboard.writeText(text).then(function () { setCopied(label); setTimeout(function () { setCopied(''); }, 2000); });
  };

  return (
    <div className="page-prettifier">
      <SEO title="Unix Timestamp Converter" description="Free online Unix timestamp converter. Convert timestamps to human-readable dates and back. Live current timestamp display." path="/timestamp" />
      <div className="container">
        <div className="tool-header">
          <h1>Unix Timestamp Converter</h1>
          <p>Convert Unix timestamps to readable dates and vice versa.</p>
        </div>
        <AdUnit />
        <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
          <div className="stat-card">
            <div className="stat-number">{now}</div>
            <div className="stat-label">Current Unix Timestamp (live)</div>
          </div>
        </div>
        <div className="editor-grid">
          <div className="editor-pane">
            <div className="pane-header"><span>Unix Timestamp</span><button onClick={function () { copy(String(ts), 'ts'); }} className="copy-btn" type="button">{copied === 'ts' ? '✓' : 'Copy'}</button></div>
            <div style={{ padding: '1rem' }}>
              <input type="number" value={ts} onChange={function (e) { setTs(parseInt(e.target.value) || 0); }} className="color-input" style={{ width: '100%', marginBottom: '0.75rem' }} aria-label="Unix timestamp" />
              <div className="case-buttons">
                <button onClick={function () { setTs(now); }} className="btn btn-secondary" type="button">Use Current Time</button>
                <button onClick={fromDate} className="btn btn-secondary" type="button">From Date String</button>
              </div>
            </div>
          </div>
          <div className="editor-pane">
            <div className="pane-header"><span>Human Readable</span><button onClick={function () { copy(dateStr, 'date'); }} className="copy-btn" type="button">{copied === 'date' ? '✓' : 'Copy'}</button></div>
            <textarea className="editor-textarea output-textarea" value={dateStr} readOnly spellCheck={false} aria-label="Date output" style={{ minHeight: '150px' }} />
          </div>
        </div>
        <section className="tool-guide">
          <h2>What is a Unix Timestamp?</h2>
          <p>A Unix timestamp is the number of seconds that have passed since January 1, 1970 (midnight UTC). Computers use timestamps internally to track time because a single number is easier to store and compare than a formatted date string. This tool helps you convert between the two formats.</p>
        </section>
      </div>
    </div>
  );
}

export default TimestampConverter;
